const contactList = document.querySelector('.sc-contact-list');

if (contactList) {
  // Axios
  const axiosGetContactList = async (parent, locations, departments, searchTerm) => {
    const action = parent.querySelector('[data-action]').value;
    const dataLocations = parent.querySelector('[data-locations]').value;
    const dataDepartments = parent.querySelector('[data-departments]').value;
    const innerElem = parent.querySelector('.contact-list__items');
    const noResultElem = parent.querySelector('.contact-list__no-result');

    const formDataInput = {
      action,
      locations,
      departments,
      searchTerm,
      defaultLocations: dataLocations,
      defaultDepartments: dataDepartments,
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      innerElem.innerHTML = '';

      if (innerElem && data.data.html_list) {
        innerElem.innerHTML = data.data.html_list;
        noResultElem.classList.add('hide');
      }

      if (noResultElem && !data.data.html_list) {
        noResultElem.classList.remove('hide');
      }

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['locations', 'departments', 'searchTerm']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));

      const moduleTop = parent.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: moduleTop - getHeaderHeight(), behavior: 'smooth' });
    } catch (err) {
      console.error(err);
    }
  };

  // Filtered values
  const getFilterValues = (parent) => {
    const checkedInputs = parent.querySelectorAll('input[type="checkbox"]:checked');
    const locations = [];
    const departments = [];

    checkedInputs.forEach((input) => {
      const name = input.getAttribute('name');
      const id = input.getAttribute('id');

      if (name === 'locations') {
        locations.push(id);
      } else if (name === 'departments') {
        departments.push(id);
      }
    });

    const locationsString = locations.join(',');
    const departmentsString = departments.join(',');

    const searchInput = parent.querySelector('input[type="text"]');
    const searchValue = searchInput ? searchInput.value.trim() : '';

    return { locations: locationsString, departments: departmentsString, searchValue };
  };

  // Filter
  const allFilterInputs = contactList.querySelectorAll('.contact-list input');

  allFilterInputs.forEach((input) => {
    const inputType = input.getAttribute('type');

    const handleInputChange = () => {
      const parent = input.closest('.contact-list');
      const { locations, departments, searchValue } = getFilterValues(parent);

      axiosGetContactList(parent, locations, departments, searchValue);
    };

    if (inputType === 'checkbox') {
      input.addEventListener('change', handleInputChange);
    } else {
      input.addEventListener('input', handleInputChange);
    }
  });
}
